// A burst of events about the logged-in user (an admin editing several permissions, or the echo of a save)
// reloads them once, after the burst
const RELOAD_DELAY_MS = 500;
let reloadTimer = null;

function reloadLoggedInUser(store) {
  clearTimeout(reloadTimer);
  reloadTimer = setTimeout(() => {
    reloadTimer = null;
    store.dispatch('user/changeNotification'); // app.GetLoggedInUser()
  }, RELOAD_DELAY_MS);
}

export default (store, { itemId, actionType }) => {
  // The socket sends itemId as a string; the store holds the user id as a number
  if (parseInt(itemId, 10) === store.state.user.id) {
    reloadLoggedInUser(store);
  } else if (actionType === 'edited') {
    store.dispatch('people/changeNotification', itemId);
  }
};
